import React from 'react';
import styled from 'styled-components';
import queryString from 'query-string';

import { HotelRatingSquare } from '@lt/components';
import { NBSP } from '../../../../constants/common';

import type { SearchParamsType } from '../../store/selectors/searchParams';

interface IHotel {
  name: string;
  stars?: number;
  rating?: number;
  link: string;
}

export type RelinkHotelsType = Array<IHotel>;

interface IHotelRelink {
  hotels: RelinkHotelsType;
  searchParams: SearchParamsType;
  className?: string;
}

const getOpenLinkHandler = (searchParams) => (e) => {
  e.preventDefault();
  const hotelLink = e.currentTarget.href;

  const query = queryString.stringify(searchParams);

  window?.open(`${hotelLink.split('?')[0]}?${query}`, '_blank')?.focus();
};

const HotelRelink: React.FC<IHotelRelink> = (props) => {
  const { hotels, searchParams, className } = props;

  return (
    <Container className={className}>
      {hotels.map((hotel) => (
        <HotelLine
          key={hotel.name}
          href={hotel.link}
          target="_blank"
          onClick={getOpenLinkHandler(searchParams)}
        >
          <HotelTitle>
            {hotel.name}
            {NBSP}
            {hotel.stars}
            {NBSP}★
          </HotelTitle>
          {hotel.rating ? (
            <HotelRatingSquare
              value={hotel.rating}
              count={hotel.rating}
              size="small"
            />
          ) : null}
        </HotelLine>
      ))}
    </Container>
  );
};

const HotelLine = styled.a`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  text-decoration: none;
  cursor: pointer;
`;

const HotelTitle = styled.div`
  font-size: 14px;
  line-height: 16px;
  padding-top: 2px;
  min-height: 20px;
  padding-right: 20px;
  color: #007aff;
`;

const Container = styled.div`
  background-color: #fff;
  width: 100%;
`;

export default HotelRelink;
